import DOSSIER from './DOSSIER/content';
import STATUT_DOC from './STATUT_DOC/content';
import QUITUS from './QUITUS/content';
import SIGN_ELEC from './SIGN_ELEC/content';
import DEPOT_DOC from './DEPOT_DOC/content';
import DEPOT_DECENNALE from './DEPOT_DECENNALE/content';
import SPEC_DOC from './SPEC_DOC/content';
import ARCHIVE from './ARCHIVE/content';
import AJOUT_DOC from './AJOUT_DOC/content';
import INVIT_CLIENT from './INVIT_CLIENT/content';
import LIST_CLIENT from './LIST_CLIENT/content';
import QUEST_MUTUAL from './QUEST_MUTUAL/content';
import QUEST_CLIENT from './QUEST_CLIENT/content';
import SUPP_CLIENT from './SUPP_CLIENT/content';
import AJOUT_ETAB from './AJOUT_ETAB/content';
import CLIENT_FAV from './CLIENT_FAV/content';
import RECHERC_CLIENT from './RECHERC_CLIENT/content';
import INVIT_FOURN from './INVIT_FOURN/content';
import RDS_2 from './RDS_2/content';
import ACCES_DOSS from './ACCES_DOSS/content';
import FOURN_FAV from './FOURN_FAV/content';
import UPLOAD_QUITUS_FOURN from './UPLOAD_QUITUS_FOURN/content';
import SUPP_FOURN from './SUPP_FOURN/content';
import PARAM_ENT from './PARAM_ENT/content';
import GESTION_INVIT from './GESTION_INVIT/content';
import GESTION_USER from './GESTION_USER/content';
import ROLE from './ROLE/content';
import PARAM_COMPT from './PARAM_COMPT/content';
import INFO_RAPP_HEBDO from './INFO_RAPP_HEBDO/content';
import MOD_MAND_DIFF from './MOD_MAND_DIFF/content';
import MOD_QUAL from './MOD_QUAL/content';
import MOD_DELEG from './MOD_DELEG/content';
import MOD_NON_DEC from './MOD_NON_DEC/content';
import MOD_NON_CIBTP from './MOD_NON_CIBTP/content';
import MOD_NON_MUT from './MOD_NON_MUT/content';
import MOD_LIST_PERS from './MOD_LIST_PERS/content';
import MOD_INVIT_CLT from './MOD_INVIT_CLT/content';
import MOD_MAND_COLL from './MOD_MAND_COLL/content';
import CONSUL_OPER from './CONSUL_OPER/content';
import MOD_MAND_OPERA from './MOD_MAND_OPERA/content';
import DEPOT_PASS_FUT_DOC from './DEPOT_PASS_FUT_DOC/content';
import CODE_ACCES from './CODE_ACCES/content';
import CREATE_OPER from './CREATE_OPER/content';
import SELECT_DOC from './SELECT_DOC/content';
import ACCESS_OPER from './ACCESS_OPER/content';
import ADD_TO_OPER from './ADD_TO_OPER/content';
import QUITUS_OPER from './QUITUS_OPER/content';
import DOWN_QUITUS_OPER from './DOWN_QUITUS_OPER/content';
import DELETE_FROM_OPER from './DELETE_FROM_OPER/content';
import CLOSE_OPER from './CLOSE_OPER/content';
import MDP from './MDP/content';
import NB_CLIENTS from './NB_CLIENTS/content';

export default [
  DOSSIER,
  STATUT_DOC,
  QUITUS,
  SIGN_ELEC,
  DEPOT_DOC,
  DEPOT_DECENNALE,
  DEPOT_PASS_FUT_DOC,
  SPEC_DOC,
  ARCHIVE,
  AJOUT_DOC,
  INVIT_CLIENT,
  LIST_CLIENT,
  QUEST_MUTUAL,
  QUEST_CLIENT,
  SUPP_CLIENT,
  AJOUT_ETAB,
  CLIENT_FAV,
  RECHERC_CLIENT,
  INVIT_FOURN,
  RDS_2,
  ACCES_DOSS,
  FOURN_FAV,
  UPLOAD_QUITUS_FOURN,
  SUPP_FOURN,
  PARAM_ENT,
  GESTION_INVIT,
  GESTION_USER,
  ROLE,
  PARAM_COMPT,
  INFO_RAPP_HEBDO,
  MOD_MAND_COLL,
  MOD_MAND_DIFF,
  MOD_QUAL,
  MOD_DELEG,
  MOD_NON_DEC,
  MOD_NON_CIBTP,
  MOD_NON_MUT,
  MOD_LIST_PERS,
  MOD_INVIT_CLT,
  CONSUL_OPER,
  MOD_MAND_OPERA,
  CODE_ACCES,
  CREATE_OPER,
  SELECT_DOC,
  ACCESS_OPER,
  ADD_TO_OPER,
  QUITUS_OPER,
  DOWN_QUITUS_OPER,
  DELETE_FROM_OPER,
  CLOSE_OPER,
  MDP,
  NB_CLIENTS
];
